module.exports = __webpack_public_path__ + "@/assets/img/whatsapp-icon.a7d128d4.png";